import React, { useState, useCallback } from 'react';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Pass1Tab from './components/Pass1Tab';
import Pass2Tab from './components/Pass2Tab';
import AccessWall from './components/AccessWall';
import { useLocalStorage } from './hooks/useLocalStorage';
import './index.css';

function App() {
  const [activeTab, setActiveTab] = useState('pass1');
  const [lastSaved, setLastSaved] = useState(Date.now());
  const [isUnlocked, setIsUnlocked] = useLocalStorage('gospelwise-access-unlocked', false);

  const handleSaveNotification = useCallback(() => {
    setLastSaved(Date.now());
  }, []);

  const [pass1State, setPass1State] = useLocalStorage(
    'gospelwise-pass1-state-v2',
    {
      chapters: [],
      macroChecks: {},
      assessment: ''
    },
    handleSaveNotification
  );

  const [pass2State, setPass2State] = useLocalStorage(
    'gospelwise-pass2-state-v2',
    {
      tool1_identified: '',
      tool1_reduce: '',
      // New dynamic Clarity Chapters
      clarityChapters: [],
      // Optional tools
      opt_paragraphs: '',
      opt_dialogue: '',
      opt_readaloud: '',
      // Plan
      plan_issue1: '',
      plan_issue2: '',
      plan_issue3: '',
      plan_goal1: '',
      plan_goal2: '',
      plan_goal3: ''
    },
    handleSaveNotification
  );

  if (!isUnlocked) {
    return <AccessWall onGrantAccess={() => setIsUnlocked(true)} />;
  }

  return (
    <div className="min-h-screen bg-offwhite font-mono text-black selection:bg-orange selection:text-black">
      <Header lastSaved={lastSaved} />
      <main className="max-w-7xl mx-auto px-6 py-10 flex flex-col md:flex-row gap-10">
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
        <div className="flex-grow pb-24">
          {activeTab === 'pass1' ? (
            <Pass1Tab state={pass1State} setState={setPass1State} />
          ) : (
            <Pass2Tab state={pass2State} setState={setPass2State} />
          )}
        </div>
      </main>
    </div>
  );
}

export default App;